<script setup>
import ContentHeader from "@/components/Dashboard/ContentHeader.vue";
import FilterOptions from "@/components/Dashboard/Devices/ArchivedDevices/FilterOptions.vue";
import DevicesTable from "@/components/Dashboard/Devices/ArchivedDevices/DevicesTable.vue";
</script>
<template>
  <ContentHeader :name="'Archived Devices'" />
  <FilterOptions />
  <DevicesTable />
</template>
